import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {Event, Activity, Day} from '../models/event';
import {Observable} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {Guid} from 'guid-typescript';
import {AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';
import {FileMaterial} from '../models/file-material';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {DepartmentService} from './department.service';
import {ConventionCenterService} from './convention-center.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  //@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  public currentEvent: Event;
  public currentDay: Day;
  public currentActivity: Activity;

  public isEdit: boolean = false;
  public localTitle: string;
  public spinner: boolean = false;

  public activityDataSource: MatTableDataSource<any>;

  private itemDoc: AngularFirestoreDocument<Activity>;
  private item: Observable<Activity>;


  public pdfDataSource: MatTableDataSource<any>
  public selectedFile: any = "Nenhum arquivo selecionado.";
  public objectPdf: any = "none";

  constructor (
    private fb: FormBuilder,
    private fs: AngularFireStorage,
    private db: AngularFirestore,
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
    public _departmentService: DepartmentService,
    public _conventionCenterService: ConventionCenterService
  ) { }

  setEdit (): any {
    if (this.currentActivity && this.currentActivity.id) {
      //   console.log("set edit true")
      this.isEdit = true
      this.localTitle = this.currentActivity.name
    } else {
      //   console.log("set edit false")
      this.isEdit = false;
      this.localTitle = "Nova Atividade"
    }
  }


  select (day_id, depto_id) {
    if (!depto_id) {
      return this.db.collection<Activity>('sbccv_event_activities', ref => ref
        .where('day_id', '==', day_id)
        .where('deleted', '==', false)).snapshotChanges()
        .subscribe((result) => {
          this.bindingDataSource(result)
        })
    } else {
      return this.db.collection<Activity>('sbccv_event_activities', ref => ref
        .where('day_id', '==', day_id)
        .where('depto_id', '==', depto_id)
        .where('deleted', '==', false)).snapshotChanges()
        .subscribe((result) => {
          this.bindingDataSource(result)
        })
    }

  }

  selectByDay (day_id: string ) {

    return this.db.collection<Activity>('sbccv_event_activities', ref => ref
      .where('day_id', '==', day_id)
      .where('deleted', '==', false)).snapshotChanges()

  }

  makeDay (data: any) {

    return data.map(item => {

      let depto: any = {}
      if (item.payload.doc.data().depto_id) {
        depto = this._departmentService.departments.find((e) => {
          return e.id === item.payload.doc.data().depto_id
        })
      }
      if(!depto){
        depto = {"id":"","deleted":false,"name":"","short":""}
      } 

      let room: any = {}
      if (item.payload.doc.data().location_id) {
        room = this._conventionCenterService.conventionCenterCurrent.rooms.find((e) => {
          return e.id === item.payload.doc.data().location_id
        })
      } else {
        room = {'name': item.payload.doc.data().location}
      }

      let activity = new Activity();
      activity.id = item.payload.doc.id;
      activity.event_id = item.payload.doc.data().event_id;
      activity.day_id = item.payload.doc.data().day_id;
      activity.name = item.payload.doc.data().name;
      activity.date = item.payload.doc.data().date;
      activity.startTime = item.payload.doc.data().startTime;
      activity.location = room ? room.name: "";
      activity.location_id = item.payload.doc.data().location_id || '';
      activity.text = item.payload.doc.data().text;
      activity.materials = item.payload.doc.data().materials;
      activity.sponsors = item.payload.doc.data().sponsors;
      activity.depto = depto.short;
      activity.depto_id = item.payload.doc.data().depto_id || '';

      //console.log(JSON.stringify(activity))

      return activity;
    });
  }

  bindingDataSource (result: any[]) {
    let array: Activity[] = []
    array = this.makeDay(result)

    array.sort(this.compareActivities)
    this.activityDataSource = new MatTableDataSource(array);
  }

  compareActivities (a, b) {
    const pa = String(a.startTime)
    const pb = String(b.startTime)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }


  selectById (id) {
    this.itemDoc = this.db.doc<Activity>('sbccv_event_activities/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert (activity: Activity) {
    this.spinner = true;
    const entity = this.createActivity(activity)
    console.log('insert: ' + JSON.stringify(entity))

    return this.db.collection('sbccv_event_activities').add(Object.assign({}, entity))
      .then((e) => {
        entity.id = e.id
        this.currentActivity = entity
        //   console.log("recent activity: " + JSON.stringify(this.currentActivity))
        this.isEdit = true;
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
        return entity;
      })
      .catch((error) => {
        console.log("erro insert activity: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })

  }

  update (id: string, activity: Activity) {
    this.spinner = true;
    const entity = this.createActivity(activity)
    console.log('update: ' + JSON.stringify(entity))

    return this.db.collection('sbccv_event_activities').doc(id).set(Object.assign({}, entity), {'merge': true})
      .then((e) => {
        this.currentActivity = entity
        this.currentActivity.id = id
        //  console.log("recent activity: " + JSON.stringify(this.currentActivity))
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("erro update activities: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })

  }


  delete (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta atividade?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        return this.db.collection('sbccv_event_activities').doc(element.id).set({deleted: true}, {merge: true})
      }
      else {
        return result
      }

    })
  }


  createActivity (data: any): Activity {
    let entity = new Activity()
    entity.name = data.name;
    //  entity.team = data.team;
    entity.text = data.text || '';
    entity.date = data.date;
    entity.location = ''; //data.location;
    entity.location_id = data.location_id || '';
    entity.event_id = data.event_id;
    entity.startTime = data.startTime;
    entity.day_id = data.day_id;
    entity.depto_id = data.depto_id || '';

    if (!this.isEdit) {
      entity.deleted = false;
    }

    return entity;
  }

  createForm (activity) {

    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      event_id: new FormControl('', [ Validators.required ]),
      day_id: new FormControl('', [ Validators.required ]),
      date: new FormControl('', [ Validators.required ]),
      //location: new FormControl('', [ Validators.required ]),
      location_id: new FormControl('', [ Validators.required ]),
      name: new FormControl('', [ Validators.required ]),
      text: new FormControl(''),
      team: new FormControl(''),
      startTime: new FormControl('', [ Validators.required ]),
      depto_id: new FormControl('', [ Validators.required ]),
    });

    form.controls.event_id.setValue(this.currentEvent.id);
    form.controls.day_id.setValue(this.currentDay.id);

    if (this.currentDay.date) {

      let anyDate: any;

      if (this.isEdit) {

        let tp: any = this.currentDay
        anyDate = new Date(tp.seconds * 1000)

      } else {
        anyDate = new Date(this.currentDay.date)
      }

      form.controls.date.setValue(anyDate);
    }

    if (activity) {
      form.controls.id.setValue(activity.id);
      form.controls.name.setValue(activity.name);
      //form.controls.location.setValue(activity.location);
      form.controls.text.setValue(activity.text);
      //    form.controls.team.setValue(activity.team);
      // console.log("day activity: " + activity.date)
      form.controls.date.setValue(new Date(activity.date.seconds * 1000));
      form.controls.startTime.setValue(activity.startTime);
      form.controls.depto_id.setValue(activity.depto_id);
      form.controls.location_id.setValue(activity.location_id);
    }


    return form
  }


  breadCrumb (value) {
    if (value) {
      if (value.length > 30) {
        return value.substr(0, 30) + "..."
      } else {
        return value
      }
    } else {
      return "Nova Atividade"
    }
  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }


  setPdfDataSource () {
    if (this.currentActivity)
      this.pdfDataSource = new MatTableDataSource(this.currentActivity.materials)
  }

  uploadFilePdf (file, label) {

    const key = Guid.create() + ".pdf";
    const fsRef: AngularFireStorageReference = this.fs.ref("events/pdfs" + key);
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          console.log("uploaded.")
          this.updateFilePdfUrl(key, file, url, label)
        });
      }))
      .subscribe();

  }

  updateFilePdfUrl (key: any, file: any, url: any, data: any) {
    if (!this.currentActivity.materials) {
      this.currentActivity.materials = []
    } else {
      this.currentActivity.materials = this.currentActivity.materials.filter((e) => {
        return e.id != key
      })
    }

    const pdf = new FileMaterial()
    pdf.id = key
    pdf.name = data.name
    pdf.original = file.name
    pdf.storage = url

    this.currentActivity.materials.push(pdf)

    return this.db.collection('sbccv_event_activities').doc(this.currentActivity.id)
      .set(JSON.parse(JSON.stringify({materials: this.currentActivity.materials})), {merge: true})
      .then(() => {
        this.setPdfDataSource()
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("activity update pdf  error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })


  }

  createPdfForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      original: new FormControl('', [ Validators.required ]),
      storage: new FormControl(''),
      url: new FormControl(''),
    });

    return form
  }


  updateBannerSponsor (activity_id, banners) {

    console.log("activity_id: " + activity_id)
    console.log("banners: " + JSON.stringify(banners))

    return this.db.collection('sbccv_event_activities').doc(activity_id).set(Object.assign({}, {'sponsors': banners}), {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("activity update banner error: " + JSON.stringify(error))
        this.snackBar.openSnackBar("Erro", '', 'error');
      })

  }

}
